import cn from "classnames";

import { ReturnModalBlockProps } from "../../ReturnModal.types";

import styles from "../../ReturnModal.module.scss";

export const ReturnModalBlock = ({
  label,
  children,
  className
}: ReturnModalBlockProps) => {
  return (
    <div className={cn(styles.returnModal_block, className)}>
      {label && <div className={styles.returnModal_block_label}>{label}</div>}
      {children}
    </div>
  );
};
